export { HyamPrismicDocumentHomePage as default } from "hyam-prismic/components";
export { hyamPrismicDocumentHomePageGetStaticProps as getStaticProps } from "hyam-prismic/components";
